import React, { Component } from 'react';
import { Table, Button, Alert, Spinner  } from 'reactstrap';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { Card, CardHeader, CardBody, Row, Col, Collapse, Input } from 'reactstrap';
import { InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import { AiOutlineSearch, AiOutlineReload } from 'react-icons/ai';
import { FaEdit, FaPlus, FaTrashAlt } from 'react-icons/fa';
import { withRouter } from 'react-router-dom';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
/*import history from "../history";*/
import './NavMenu.css';
import url from "./variables/url.js";
import { AppContext } from '../AppContext';
import Paginacion from './Paginacion';
import ActividadCard from './ActividadCard';
import InsigniasAdmin from './InsigniasAdmin';

/*const localBack = url.localBack;*/
const localBack = process.env.REACT_APP_BACK;
const homepage = process.env.REACT_APP_EXP;


export class ConsultarPerfil extends Component {
    static displayName = ConsultarPerfil.name;

    constructor(props) {
        super(props);
        this.state = {
            buscar: '',
            buscarNombre: '',
            loading: false,
            activeTab: 1,
            collapse: 1,
            idestudiante: 0,
            actividades: [],
            categorias: [],
            tipos: [],
            iduser: 0,
            idEstudianteSeleccionado: 0,
            nombreEstudiante: "",
            identificacionEstudiante: "",
            matriculaEstudiante: "",
            username: "",
            foto: "",
            estudianteSeleccionado: false,
            cargando: false,
            mensaje: "",
            roles: [],
            currentActividades: [], currentPage: null, totalPages: null,
            pestanias: [{id: 1, nombre: 'Matricula' },{id: 2, nombre: 'Apellidos/Nombres' }],
        };

        this.toggle = this.toggle.bind(this);
        this.toggleCard = this.toggleCard.bind(this);        
        this.searchById = this.searchById.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleSearchNombre = this.handleSearchNombre.bind(this);
        this.actualizarActividades = this.actualizarActividades.bind(this);
        this.onChangeLimite = this.onChangeLimite.bind(this);
        
    }

    componentDidMount() {        
        let currentUser = this.context;
        if (currentUser != null && this.state.iduser == 0) {
            this.setState({ iduser: currentUser.idpersona, roles: currentUser.roles });
            if (currentUser.roles.includes('ADMINISTRADOR')) {
                //console.log('Ok');
            } else {
                this.isForbidden();
            }

        }
    }

    componentDidUpdate() {
        let currentUser = this.context;
        if (currentUser != null && this.state.iduser == 0) {
            this.setState({ iduser: currentUser.idpersona, roles: currentUser.roles });
            if (currentUser.roles.includes('ADMINISTRADOR')) {
                //console.log('Ok');
            } else {
                this.isForbidden();
            }

        }
    }

    isForbidden() {
        this.props.history.push({
            pathname: homepage,
        })
    }

    actualizarActividades(actividad) {
        let actividades = this.state.actividades;
        let indice = actividades.indexOf(actividad);
        actividades[indice] = actividad;
        this.setState({ actividades: actividades });
    }

    onChangeLimite(event) {
        //console.log('Cambio limite');
        //console.log(event.target.value);
        var num = event.target.value;
        this.setState({ limite: num });
        this.reLoadTotalPage(this.state.actividades.length, num);
    }

    KeyPressEstudiante = (event) => {
        if (event.charCode === 13 && this.state.buscar !== "") {    
            this.searchById();
        }
    }

    KeyPressEstudianteNombre = (event) => {
        if (event.charCode === 13 && this.state.buscarNombre !== "") {
            this.searchByNombre();
        }
    }

    render() {
        let contents = <InsigniasAdmin iduser={this.state.idEstudianteSeleccionado} />;

        let contentLoading = this.cargando ? 
                (<><Spinner animation="grow" /></>)
                : (<br />);

        let contentSearch = this.loading ? <><Spinner animation="grow" /></> : (this.state.estudianteSeleccionado
            ? <><div className="boton_actualizar"><Button color="primary" onClick={() => window.location.reload(false)}><AiOutlineReload /></Button></div>
                <div className="row">
                    <div className="col-md-2">
                        <img src={this.state.foto} alt="foto de perfil" width="500" height="500" />
                    </div>
                    <div className="col-md-10">
                        <div><strong>Nombre: </strong>{this.state.nombreEstudiante} </div>
                        <div><strong>Identificaci&oacute;n: </strong>{this.state.identificacionEstudiante} </div>
                        <div><strong>Matricula: </strong>{this.state.matriculaEstudiante}</div>
                    </div>
                </div></> :
            <><Nav pills>
                {this.state.pestanias.map((pes, i) =>
                    <NavItem key={i}>
                        <NavLink className="icon-pointer" active={pes.id === this.state.activeTab} onClick={() => { this.toggle(pes.id); }}>
                            {pes.nombre}
                        </NavLink>
                    </NavItem>
                )}
            </Nav>
                <hr />
                <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId={1}>
                        <Row>
                            <InputGroup className="col-md-6">
                                <Input placeholder="20210..." onChange={this.handleSearch} onKeyPress={this.KeyPressEstudiante} value={this.state.buscar} />
                                <InputGroupAddon addonType="append">
                                    <InputGroupText onClick={() => this.searchById()}>
                                        <AiOutlineSearch />
                                    </InputGroupText>
                                </InputGroupAddon>
                            </InputGroup>
                        </Row>
                        <hr />
                    </TabPane>
                    <TabPane tabId={2}>
                        <Row>
                            <InputGroup className="col-md-6">
                                <Input placeholder="APELLIDOS NOMBRE..." onChange={this.handleSearchNombre} onKeyPress={this.KeyPressEstudianteNombre} value={this.state.buscarNombre} />
                                <InputGroupAddon addonType="append">
                                    <InputGroupText onClick={() => this.searchByNombre()}>
                                        <AiOutlineSearch />
                                    </InputGroupText>
                                </InputGroupAddon>
                            </InputGroup>
                        </Row>
                        <hr />
                    </TabPane>
                </TabContent></>);


        return (
            <div>
                {contentSearch}
                {contentLoading}
                {contents}
            </div>
        );
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {            
            this.setState({
                activeTab: tab
            });
        }
    }

    toggleCard(e) {
        let event = e.target.dataset.event;
        this.setState({ collapse: this.state.collapse === Number(event) ? 0 : Number(event) });        
    }    

    handleSearch = async function(event) {
        await this.setState({ buscar: event.target.value });        
    }

    handleSearchNombre = async function (event) {
        //console.log(event.target.value);
        await this.setState({ buscarNombre: event.target.value });
    }

    searchById() {
        this.setState({ cargando: true });

        Swal.fire({
            title: "Cargando...",
            html: "Por favor, espere",
            timerProgressBar: true,
            button: false,
            closeOnClickOutside: false,
            showConfirmButton: false,
            closeOnEsc: false,
            allowOutsideClick: false
        });
        Swal.showLoading();

        if (this.state.buscar !== '') {
            fetch(localBack + '/api/Persona/GetByEstudiante/' + this.state.buscar, {
                method: 'GET',
            })
            .then(response => {
                this.setState({ status: response.status });
                return response.json();
            })
            .then(data => {
                if (data.strEstado == 'S' && data.objDatos != null) {
                    if (data.objDatos.idpersona != null
                        && data.objDatos.codestudiante != null
                        && data.objDatos.numeroidentificacion != null && data.objDatos.email != null) {
                        fetch('https://ws.espol.edu.ec/carnetvirtual/api/fotoperfil/getfotoperfil?netid=' + data.objDatos.email.split("@")[0], {
                            method: 'GET',
                        })
                            .then(response => {
                                return response.json();
                            })
                            .then(resultData => {
                                this.setState({
                                    idEstudianteSeleccionado: data.objDatos.idpersona, cargando: false, estudianteSeleccionado: true, mensaje: "",
                                    matriculaEstudiante: data.objDatos.codestudiante,
                                    identificacionEstudiante: data.objDatos.numeroidentificacion,
                                    nombreEstudiante: data.objDatos.apellidos + " " + data.objDatos.nombres,
                                    username: data.objDatos.email.split("@")[0],
                                    foto: resultData.fotoString,
                                });
                                Swal.close();
                            });
                    }
                    else {
                        this.setState({ idEstudianteSeleccionado: 0, cargando: false, estudianteSeleccionado: false, mensaje: "Usuario no encontrado" });
                        Swal.fire({
                            title: 'Error',
                            icon: 'error',
                            html: "Error en la busqueda del estudiante"
                        });
                    }
                } else {
                    this.setState({ idEstudianteSeleccionado: 0, cargando: false, estudianteSeleccionado: false, mensaje: "Usuario no encontrado" });
                    Swal.fire({
                        title: 'Error',
                        icon: 'error',
                        html: "Error en la busqueda del estudiante"
                    });
                }
            });
        } else {
            this.setState({ idEstudianteSeleccionado: 0, cargando: false, estudianteSeleccionado: false, mensaje: "Usuario no encontrado" });
            Swal.fire({
                title: 'Error',
                icon: 'error',
                html: "Error en la busqueda del estudiante"
            });
        }        
    }

    searchByNombre() {
        this.setState({ cargando: true });

        Swal.fire({
            title: "Cargando...",
            html: "Por favor, espere",
            timerProgressBar: true,
            button: false,
            closeOnClickOutside: false,
            showConfirmButton: false,
            closeOnEsc: false,
            allowOutsideClick: false
        });
        Swal.showLoading();

        if (this.state.buscarNombre !== '') {
            fetch(localBack + '/api/Persona/GetByNombre/' + this.state.buscarNombre, {
                method: 'GET',
            })
            .then(response => {
                this.setState({ status: response.status });
                return response.json();
            })
            .then(data => {
                if (data.strEstado == 'S' && data.objDatos != null) {
                    if (data.objDatos.idpersona != null
                        && data.objDatos.codestudiante != null
                        && data.objDatos.numeroidentificacion != null && data.objDatos.email != null) {
                        fetch('https://ws.espol.edu.ec/carnetvirtual/api/fotoperfil/getfotoperfil?netid=' + data.objDatos.email.split("@")[0], {
                            method: 'GET',
                        })
                            .then(response => {
                                return response.json();
                            })
                            .then(resultData => {
                                this.setState({
                                    idEstudianteSeleccionado: data.objDatos.idpersona, cargando: false, estudianteSeleccionado: true, mensaje: "",
                                    matriculaEstudiante: data.objDatos.codestudiante,
                                    identificacionEstudiante: data.objDatos.numeroidentificacion,
                                    nombreEstudiante: data.objDatos.apellidos + " " + data.objDatos.nombres,
                                    username: data.objDatos.email.split("@")[0],
                                    foto: resultData.fotoString,
                                });
                                Swal.close();
                            });
                    }
                    else {
                        this.setState({ idEstudianteSeleccionado: 0, cargando: false, estudianteSeleccionado: false, mensaje: "Usuario no encontrado" });
                        Swal.fire({
                            title: 'Error',
                            icon: 'error',
                            html: "Error en la busqueda del estudiante"
                        });
                    }
                } else {
                    this.setState({ idEstudianteSeleccionado: 0, cargando: false, estudianteSeleccionado: false, mensaje: "Usuario no encontrado" });
                    Swal.fire({
                        title: 'Error',
                        icon: 'error',
                        html: "Error en la busqueda del estudiante"
                    });
                }
            });
        } else {
            this.setState({ idEstudianteSeleccionado: 0, cargando: false, estudianteSeleccionado: false, mensaje: "Usuario no encontrado" });
            Swal.fire({
                title: 'Error',
                icon: 'error',
                html: "Error en la busqueda del estudiante"
            });
        }
    }

    onlyNumber = (event) => {
        if (!/[0-9]/.test(event.key)) {
            event.preventDefault();
        }
    };

}
ConsultarPerfil.contextType = AppContext;
export default withRouter(ConsultarPerfil);